export const linkDefaultParams = (url: string, againVals: any) => {
  // console.log('defParams', againVals, Object.keys(againVals))
  const stringUrl = Object.keys(againVals).filter(id => againVals[id]).map(id =>
    'd[' + id + ']=' + encodeURIComponent(againVals[id])
  ).join('&')

  return url + '?' + stringUrl
}




